import { render, staticRenderFns } from "./VisitsTable.vue?vue&type=template&id=067d33da"
import script from "./VisitsTable.vue?vue&type=script&lang=js"
export * from "./VisitsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports